import { BoardCollectionsSelectView } from 'app/scripts/views/board-menu/BoardCollectionsSelectView';
import { BoardAddToTeamView } from 'app/scripts/views/board-menu/BoardAddToTeamView';
import { Auth } from 'app/scripts/db/auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { View } from 'app/scripts/views/internal/view';
import { sendErrorEvent } from '@trello/error-reporting';
import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('board_collections');

const spinnerTemplate = t.renderable(() => {
  t.div(() => {
    t.div('.spinner.loading');
  });
});

class SpinnerView extends View {
  render() {
    return this.$el.html(spinnerTemplate());
  }
}

class OnlyForTeamMembers extends View {
  static vigor = this.VIGOR.NONE;
  renderOnce() {
    return this.$el.html(
      t.render(() => {
        t.div('.count-explanation', () => {
          t.p(() => t.format('only-team-members-can-enable-collections'));
        });
      }),
    );
  }
}

class BoardCollectionsView extends View {
  viewTitleKey = 'collections';

  className() {
    return 'board-menu-content-frame board-collections-view';
  }

  static initClass() {
    this.prototype.noPadding = true;
  }

  initialize() {
    this.sidebarView = this.options.sidebarView;

    this.listenTo(this.model, 'team-has-bc', () => {
      this.redirecting = false;
      this.addToTeam = false;
      this.render();
    });
    this.listenTo(this.model, 'added-to-team', () => {
      this.redirecting = true;
      this.render();
    });
    this.listenTo(this.model, 'cancel-add-to-team', () => {
      this.addToTeam = false;
      this.render();
    });
    this.listenTo(this.model, 'cancel-upgrade', () => {
      this.initialViewState = null;
      this.render();
    });
    this.listenTo(this.model, 'add-to-team', () => {
      if (!this.model.owned()) {
        // We aren't an admin on this board so redirect to business-class page
        window.location = '/business-class';
      } else {
        this.initialViewState = null;
        this.addToTeam = true;
        this.render();
      }
    });
  }

  render() {
    try {
      this.$el.empty();

      const board = this.model;
      const boardBelongsToTeam = board.hasOrganization();
      const team = board.getOrganization();
      const me = Auth.me();

      const isBoardMember = board.isMember(me);
      const isTeamMember = team?.isMember(me);
      const notMember = !isBoardMember && !isTeamMember;
      const publicBoardAndTeam = board.isPublic() && team?.isPublic();
      const shouldRenderOnlyForTeamMembers =
        boardBelongsToTeam &&
        ((isBoardMember && !isTeamMember) || (notMember && publicBoardAndTeam));

      if (this.redirecting) {
        this.renderSpinner();
      } else if (this.addToTeam) {
        this.renderAddToTeam();
      } else if (shouldRenderOnlyForTeamMembers) {
        this.renderOnlyForTeamMembers();
      } else {
        this.renderTagSelect();
      }
    } catch (err) {
      sendErrorEvent(err, {
        tags: {
          ownershipArea: 'trello-panorama',
          feature: 'Collections',
        },
      });
    }
  }

  renderOnlyForTeamMembers() {
    this.appendSubview(this.subview(OnlyForTeamMembers, this.model));
  }

  renderSpinner() {
    this.appendSubview(this.subview(SpinnerView, this.model));
  }

  renderAddToTeam() {
    if (this.model.hasOrganization()) {
      // So the board is part of a team, we just can't see it
      // This is a weird situation; we're just not going to let them
      // mess with the power-ups in this case
      this.appendSubview(this.subview(OnlyForTeamMembers, this.model));
      return this;
    }

    ModelLoader.loadMyOrganizations();

    this.appendSubview(
      this.subview(BoardAddToTeamView, this.model, {
        menuType: 'Collections',
      }),
    );
  }

  renderTagSelect() {
    this.appendSubview(
      this.subview(BoardCollectionsSelectView, this.model, {
        modelCache: this.modelCache,
        sidebarView: this.sidebarView,
      }),
    );
  }
}
BoardCollectionsView.initClass();
export { BoardCollectionsView };
